import { useCallback } from 'react';

import type {
  ExternalSigningDevicesNestedById,
  MultiSigWalletsNestedById,
  PrivateKeysNestedById,
  SeedPhrasesNestedById,
  WalletsV2Dataset,
} from '@infinex/types';
import { getWalletsV2NestedRepresentation } from '@infinex/types';
import type { GenericDatasetState } from '@infinex/user';
import { useMappedDataset } from '@infinex/user';

/**
 * @returns Seed phrases, private keys, external signing devices, and multi-sig wallets, each keyed by ID
 */
export function useWalletsV2Nested(): GenericDatasetState<{
  seedPhrases: SeedPhrasesNestedById;
  privateKeys: PrivateKeysNestedById;
  externalSigningDevices: ExternalSigningDevicesNestedById;
  multiSigWallets: MultiSigWalletsNestedById;
}> {
  return useMappedDataset(
    'walletsV2',
    useCallback(
      (
        walletsV2Data: WalletsV2Dataset
      ): {
        seedPhrases: SeedPhrasesNestedById;
        privateKeys: PrivateKeysNestedById;
        externalSigningDevices: ExternalSigningDevicesNestedById;
        multiSigWallets: MultiSigWalletsNestedById;
      } => {
        return getWalletsV2NestedRepresentation(walletsV2Data);
      },
      []
    )
  );
}
